(function () {
  function init(root) {
    root.querySelectorAll('[data-digi-countdown-section]').forEach(function (section) {
      var timer = section.querySelector('[data-digi-countdown-timer]');
      if (!timer) return;
      if (timer._digiInterval) clearInterval(timer._digiInterval);
      var date = (timer.dataset.countdownDate || '').trim().replace(/\./g, '/');
      var br = date.match(/^(\d{2})[\/-](\d{2})[\/-](\d{4})$/);
      if (br) date = br[3] + '-' + br[2] + '-' + br[1];
      var time = (timer.dataset.countdownTime || '23:59').trim();
      var valid = date.match(/^(\d{4})[\/-](\d{2})[\/-](\d{2})$/) && time.match(/^([01]?\d|2[0-3]):[0-5]\d$/);
      if (!valid) { timer.dataset.countdownInvalid = 'true'; return; }
      var end = Date.parse(date.replace(/\//g, '-') + 'T' + time + ':00-03:00');
      if (!Number.isFinite(end)) { timer.dataset.countdownInvalid = 'true'; return; }
      delete timer.dataset.countdownInvalid;
      var strip = section.querySelector('[data-digi-countdown-strip]');
      var message = section.querySelector('[data-countdown-expired]');
      var days = timer.querySelector('[data-countdown-days]');
      var hours = timer.querySelector('[data-countdown-hours]');
      var minutes = timer.querySelector('[data-countdown-minutes]');
      var seconds = timer.querySelector('[data-countdown-seconds]');
      function pad(n) { return String(Math.max(0,n)).padStart(2,'0'); }
      function tick() {
        var remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (days) days.textContent = pad(Math.floor(remaining / 86400));
        if (hours) hours.textContent = pad(days ? Math.floor(remaining % 86400 / 3600) : Math.floor(remaining / 3600));
        if (minutes) minutes.textContent = pad(Math.floor(remaining % 3600 / 60));
        if (seconds) seconds.textContent = pad(remaining % 60);
        if (remaining > 0) return;
        clearInterval(timer._digiInterval); timer._digiInterval = null;
        var behavior = timer.dataset.countdownExpireBehavior || 'message';
        if (behavior === 'hide_card') strip.hidden = true;
        else { timer.hidden = true; if (behavior === 'message' && message) message.hidden = false; }
      }
      strip.hidden = false; timer.hidden = false; if (message) message.hidden = true;
      tick(); if (!timer.hidden && !strip.hidden) timer._digiInterval = setInterval(tick, 1000);
    });
  }
  function ready() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { event.target.querySelectorAll('[data-digi-countdown-timer]').forEach(function (timer) { clearInterval(timer._digiInterval); }); });
})();
